// MODES:
module.exports = [
  {
    id: "ffa",
    name: "Free for All",
    alias: "ffa",
  },
  {
    id: "tdm",
    name: "Team Deathmatch",
    endStats: ["sid", "name", "score", "kills", "deaths", "assists", "reward"],
    alias: "tdm",
    teams: true,
  },
  {
    id: "point",
    name: "Hardpoint",
    alias: "point",
    endStats: [
      "sid",
      "name",
      "score",
      "kills",
      "deaths",
      "objective",
      "reward",
    ],
    objective: true,
    teams: true,
    gameStart: function (game) {
      game.activeObjective = -1;
      game.nextObjective(null, true);
    },
  },
  {
    id: "ctf",
    name: "Capture the Flag",
    alias: "ctf",
    endStats: ["sid", "name", "score", "kills", "deaths", "caps", "reward"],
    onKill: function (game, io, player) {
      game.dropFlag(player.flag);
    },
    flags: true,
    teams: true,
    noScoreC: true,
  },
  {
    id: "bhop",
    name: "Parkour",
    alias: "bhop",
    sendR: 5,
    endStats: ["sid", "name", "score", "deaths"],
    noKick: true,
    friendly: true,
  },
  {
    id: "hide",
    name: "Hide & Seek",
    alias: "hide",
    endStats: ["sid", "name", "score", "found", "reward"],
    winCondition: function (game) {
      var d = 0;
      for (var f = 0; f < game.players.list.length; ++f) {
        if (game.players.list[f].active && game.players.list[f].team == 1) {
          d++;
        }
      }
      if (d > 0) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].active && c.players.list[f].team == 1) {
            d++;
          }
        }
        return d > 0;
      },
    ],
    minPlayers: 2,
    waitTimers: [
      {
        time: 10000,
        msg: "picking seeker in ",
        trigger: function (c) {
          c.pickSeeker();
        },
      },
      {
        time: 45000,
        msg: "releasing seeker in ",
        trigger: function (c) {
          c.releaseSeeker();
        },
      },
    ],
    spdMlt: {
      1: 0.8,
    },
    teams: true,
    teamOptions: ["Hiders", "Seekers"],
    killConv: true,
    noKick: true,
    showTeam: true,
    convTeam: 2,
    convWord: "found",
    noWeap: true,
    friendly: true,
    hideNames: true,
  },
  {
    id: "infect",
    name: "Infected",
    alias: "infect",
    endStats: ["sid", "name", "score", "kills", "infected", "reward"],
    winCondition: function (c) {
      var d = 0;
      for (var f = 0; f < c.players.list.length; ++f) {
        if (c.players.list[f].active && c.players.list[f].team == 1) {
          d++;
        }
      }
      if (d > 0) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].active && c.players.list[f].team == 1) {
            d++;
          }
        }
        return d > 0;
      },
    ],
    minPlayers: 2,
    waitTimers: [
      {
        time: 20000,
        msg: "infection in ",
        trigger: function (c) {
          c.infectRandom();
        },
      },
    ],
    teamClass: {
      2: 9,
    },
    spdMlt: {
      2: 1.15,
    },
    killConv: true,
    noKick: true,
    teams: true,
    teamOptions: ["Survivors", "Infected"],
    convWord: "infected",
    convTeam: 2,
  },
  {
    id: "race",
    name: "Race",
    alias: "race",
    sendR: 5,
    endStats: ["sid", "name", "score", "time"],
    gameTime: 0,
    showMS: true,
    timed: true,
    endSort: function (c, d) {
      if (c.score === d.score && c.gameTimer && d.gameTimer) {
        return c.gameTimer - d.gameTimer;
      } else {
        return d.score - c.score;
      }
    },
    gameStart: function (c) {
      c.lockMove();
      c.targetScore = 0;
      for (var d = 0; d < c.map.manager.objects.length; ++d) {
        if (c.map.manager.objects[d].score) {
          c.targetScore += c.map.manager.objects[d].scoreP;
        }
      }
    },
    condition: [
      function (c) {
        for (var d = 0; d < c.players.list.length; ++d) {
          if (
            c.players.list[d].score >= c.targetScore &&
            !c.players.list[d].timer
          ) {
            c.players.list[d].timer = c.lastTimer;
            c.players.list[d].gameTimer = c.gameTimer;
            c.waitTimers ||= [
              {
                time: 10000,
                contTime: true,
                msg: "race ends in ",
                trigger: function (f) {
                  f.gameTimer = "skip";
                },
              },
            ];
          }
        }
        return true;
      },
    ],
    waitTimers: [
      {
        time: 15000,
        msg: "race starting in ",
        trigger: function (c) {
          c.unlockMove();
        },
      },
    ],
    noWeap: true,
    friendly: true,
  },
  {
    id: "lms",
    name: "Last Man Standing",
    alias: "lms",
    endStats: ["sid", "name", "score", "kills", "deaths", "assists"],
    noRegen: true,
    noKick: true,
    teams: true,
    lives: 1,
    winCondition: function (c) {
      var d = 0;
      var f = 0;
      for (var g = 0; g < c.players.list.length; ++g) {
        if (c.players.list[g].lives > 0) {
          var h = c.players.list[g].lives;
          if (c.players.list[g].team == 1) {
            d += h;
          } else {
            f += h;
          }
        }
      }
      if (d > f) {
        return 1;
      } else {
        return 2;
      }
    },
    gameTime: 300000,
  },
  {
    id: "simon",
    name: "Simon Says",
    alias: "simon",
    endStats: ["sid", "name", "score", "reward"],
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].active && c.players.list[f].team == 1) {
            d++;
          }
        }
        return d > 0;
      },
    ],
    minPlayers: 3,
    waitTimers: [
      {
        time: 10000,
        msg: "starts in ",
        trigger: function (c) {
          c.pickSimon();
        },
      },
    ],
    teams: true,
    teamOptions: ["Followers", "Simon"],
    noKick: true,
    teamSee: ["Followers", "Simon"],
  },
  {
    id: "gun",
    name: "Gun Game",
    alias: "gun",
    endStats: [
      "sid",
      "name",
      "weapon",
      "kills",
      "melees",
      "setbacks",
      "reward",
    ],
    leaderStat: "weaponTier",
    endSort: function (c, d) {
      if (c.weaponTier === d.weaponTier && c.kills && d.kills) {
        return c.kills - d.kills;
      } else {
        return d.weaponTier - c.weaponTier;
      }
    },
    winCondition: function (c) {
      var d = 0;
      var f = null;
      for (var g = 0; g < c.players.list.length; ++g) {
        if (f == null || c.players.list[g].weaponTier > d) {
          d = c.players.list[g].weaponTier;
          f = c.players.list[g];
        }
      }
      if (d == 0) {
        return null;
      } else {
        return f;
      }
    },
    condition: [
      function (c) {
        for (var d = 0; d < c.players.list.length; ++d) {
          if (c.players.list[d].weaponTier >= c.mode.weaponOrder.length) {
            return false;
          }
        }
        return true;
      },
    ],
    onKill: function (c, d, f, g, h) {
      if (g && g != f) {
        if (
          c.weaponConfig[h.wId == null ? g.loadout[g.weaponIndex] : h.wId].melee
        ) {
          c.decreaseWeapon(f);
          if (g.weaponTier == c.mode.weaponOrder.length - 1) {
            c.increaseWeapon(g, h);
          }
        } else {
          c.increaseWeapon(g, h);
        }
      } else {
        c.decreaseWeapon(f);
      }
      if (d) {
        c.players.syncLeaders();
      }
    },
    startingLoadout: [2],
    keepLoadout: true,
    rewardMlt: 50,
    noReward: true,
    noAssists: true,
    noStreaks: true,
    minPlayers: 2,
    noWeap: true,
    noPickups: true,
    weaponOrder: [2, 16, 10, 4, 11, 5, 3, 9, 1, 14, 6, 0, 7, 8, 13, 15, 12],
  },
  {
    id: "prop",
    name: "Prop Hunt",
    alias: "prop",
    genID: "p",
    tickR: 20,
    endStats: ["sid", "name", "score", "kills"],
    noRegen: true,
    noKick: true,
    // teams: true,
    lives: 1,
    winCondition: function (c) {
      var d = 0;
      for (var f = 0; f < c.players.list.length; ++f) {
        if (c.players.list[f].active && c.players.list[f].team == 1) {
          d++;
        }
      }
      if (d > 0) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        var f = 0;
        for (var g = 0; g < c.players.list.length; ++g) {
          if (c.players.list[g].lives > 0 && c.players.list[g].active) {
            if (c.players.list[g].team == 1) {
              d++;
            } else {
              f++;
            }
          }
        }
        return d >= 1 && f >= 1;
      },
    ],
    minPlayers: 2,
    waitTimers: [
      {
        time: 10000,
        msg: "locking seekers in ",
        trigger: function (c) {
          c.lockSeekers();
        },
      },
      {
        time: 30000,
        msg: "releasing seekers in ",
        noJoin: true,
        trigger: function (c) {
          c.releaseSeeker();
        },
      },
    ],
    teams: true,
    teamOptions: ["Prop", "Seekers"],
    teamSort: true,
    showTeam: true,
    hideNames: true,
  },
  {
    id: "boss",
    name: "Boss Hunt",
    alias: "boss",
    winCondition: function (c) {
      var d = 0;
      for (var f = 0; f < c.players.list.length; ++f) {
        if (c.players.list[f].active && c.players.list[f].team == 2) {
          d++;
        }
      }
      if (d > 0) {
        return 2;
      } else {
        return 1;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].active && c.players.list[f].team == 2) {
            d++;
          }
        }
        return d > 0;
      },
    ],
    waitTimers: [
      {
        time: 15000,
        msg: "picking boss in ",
        trigger: function (c) {
          c.pickBoss();
        },
      },
    ],
    teams: true,
    teamOptions: ["Heros", "Boss"],
    noReward: true,
    minPlayers: 2,
  },
  {
    id: "ranked",
    name: "Ranked",
    alias: "ranked",
    noReward: true,
    preventCustomGames: true,
    endStats: ["sid", "name", "score", "kills", "deaths", "MMR"],
    isRanked: true,
    noKick: true,
    needAll: true,
    infEndTimer: true,
    objective: true,
    teams: true,
    forceSpawn: 15,
    waitTimers: [
      {
        time: 10000,
        msg: "starts in ",
        trigger: function (c) {
          c.unlockMove();
        },
      },
    ],
    gameStart: function (c) {
      c.lockMove();
      c.activeObjective = -1;
      c.nextObjective(null, true);
    },
  },
  {
    id: "ranked",
    name: "Ranked",
    alias: "ranked",
    noReward: true,
    preventCustomGames: true,
    endStats: ["sid", "name", "score", "kills", "deaths", "MMR"],
    isRanked: true,
    noKick: true,
    needAll: true,
    infEndTimer: true,
    noRegen: true,
    killSort: true,
    forceSpawn: 15,
    winCondition: function (c) {
      var d = 0;
      var f = null;
      for (var g = 0; g < c.players.list.length; ++g) {
        if (f == null || c.players.list[g].kills > d) {
          d = c.players.list[g].kills;
          f = c.players.list[g];
        }
      }
      if (d == 0) {
        return null;
      } else {
        return f;
      }
    },
    condition: [
      function (c) {
        for (var d = 0; d < c.players.list.length; ++d) {
          if (c.players.list[d].kills >= 10) {
            return false;
          }
        }
        return true;
      },
    ],
    waitTimers: [
      {
        time: 10000,
        msg: "starts in ",
        trigger: function (c) {
          c.unlockMove();
        },
      },
    ],
    gameStart: function (c) {
      c.lockMove();
    },
  },
  {
    id: "stalk",
    name: "Stalker",
    alias: "stalk",
    endStats: ["sid", "name", "score", "reward"],
    genID: "st",
    ambInd: 5,
    minPlayers: 2,
    fogD: 250,
    fogC: 1842204,
    skyCol: 1842204,
    lightCol: 855309,
    ambCol: 1513239,
    lives: 1,
    condition: [
      function (c) {
        var d = 0;
        var f = 0;
        for (var g = 0; g < c.players.list.length; ++g) {
          if (c.players.list[g].lives > 0) {
            if (c.players.list[g].team == 1) {
              d++;
            } else if (c.players.list[g].team == 2) {
              f++;
            }
          }
        }
        return d >= 1 && f >= 1;
      },
    ],
    winCondition: function (c) {
      var d = 0;
      for (var f = 0; f < c.players.list.length; ++f) {
        if (c.players.list[f].active && c.players.list[f].team == 2) {
          d++;
        }
      }
      if (d > 0) {
        return 2;
      } else {
        return 1;
      }
    },
    waitTimers: [
      {
        time: 15000,
        msg: "picking stalker in ",
        trigger: function (c) {
          c.pickStalker();
        },
      },
    ],
    onMelee: function (c, d, f) {
      var g = d && f && d.team == 2;
      if (g) {
        c.triggerImgSound("jumpS_0", "jumpS_0", f);
        c.players.changeHealth(d, null, -40);
      }
      return g;
    },
    hideNames: true,
    noReward: true,
    noKick: true,
    teams: true,
    teamOptions: ["Living", "Stalker"],
    spdMlt: {
      1: 0.65,
    },
  },
  {
    id: "king",
    name: "King of the Hill",
    alias: "king",
    endStats: [
      "sid",
      "name",
      "score",
      "kills",
      "deaths",
      "objective",
      "reward",
    ],
    objective: true,
    noScoreK: true,
    objScore: 20,
    gameStart: function (c) {
      c.activeObjective = -1;
      c.nextObjective(null, true);
    },
  },
  {
    id: "oinc",
    name: "One in the Chamber",
    alias: "oinc",
    endStats: ["sid", "name", "kills", "deaths", "melees"],
    leaderStat: "lives",
    endSort: function (c, d) {
      if (c.lives === d.lives && c.kills && d.kills) {
        return d.kills - c.kills;
      } else {
        return d.lives - c.lives;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].lives > 0) {
            d++;
          }
        }
        return d > 1;
      },
    ],
    winCondition: function (c) {
      for (var d = 0; d < c.players.list.length; ++d) {
        if (c.players.list[d].lives > 0) {
          return c.players.list[d];
        }
      }
      return null;
    },
    waitTimers: [
      {
        time: 10000,
        msg: "starts in ",
        trigger: function (c) {
          c.unlockMove();
        },
      },
      {
        time: 100,
        msg: "",
        noJoin: true,
        trigger: function () {},
      },
    ],
    gameStart: function (c) {
      c.lockMove();
    },
    onKill: function (c, d, f, g) {
      if (g && g != f) {
        g.ammos[0]++;
        if (g.ammos[0] > 7) {
          g.ammos[0] = 7;
        }
        d.send(g.id, "uamo", g.ammos);
      }
      if (d) {
        c.players.syncLeaders();
      }
    },
    forceSpawn: 3,
    lives: 3,
    aK3: 10,
    forceClass: 10,
    ammoLimit: 1,
    noReloads: true,
    hideNames: true,
    noReward: true,
    noAssists: true,
    noStreaks: true,
    minPlayers: 2,
    noPickups: true,
  },
  {
    id: "trade",
    name: "Trade",
    sendR: 5,
    endStats: ["sid", "name", "score"],
    alias: "trade",
    noKick: true,
    canTrade: true,
    friendly: true,
    gameTime: 0,
  },
  {
    id: "kc",
    name: "Kill Confirmed",
    alias: "kc",
    endStats: [
      "sid",
      "name",
      "score",
      "kills",
      "deaths",
      "confirms",
      "denies",
      "reward",
    ],
    endSort: function (c, d) {
      if (c.confirms === d.confirms && c.kills && d.kills) {
        return d.kills - c.kills;
      } else {
        return d.confirms - c.confirms;
      }
    },
    winCondition: function (c) {
      var d;
      var f = 0;
      var g = 0;
      for (var h = 0; h < c.players.list.length; ++h) {
        d = c.players.list[h].confirms;
        if (c.players.list[h].team == 1) {
          f += d;
        } else {
          g += d;
        }
      }
      if (f > g) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d;
        var f = 0;
        var g = 0;
        for (var h = 0; h < c.players.list.length; ++h) {
          d = c.players.list[h].confirms;
          if (c.players.list[h].team == 1) {
            f += d;
          } else {
            g += d;
          }
        }
        return !(f >= c.mode.tagLimit) && !(g >= c.mode.tagLimit);
      },
    ],
    onKill: function (c, d, f) {
      c.dropSpawnable(0, f);
    },
    tagLimit: 65,
    teams: true,
    noScoreC: true,
  },
  {
    id: "def",
    name: "Defuse",
    alias: "def",
    site: true,
    endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
    lives: 1,
    noRegen: true,
    teams: true,
    hitBoxPad: 0.5,
    gameStart: function (c) {
      c.warmupReset();
      c.lockMove();
    },
    realMov: true,
    winCondition: function (c) {
      var d;
      var f = 0;
      for (var g = 0; g < c.players.list.length; ++g) {
        d = c.players.list[g].team;
        if (c.players.list[g].diffuses) {
          return d;
        }
        if (c.players.list[g].active) {
          if (d == 1) {
            f++;
          } else if (d == 2) {
            0;
          }
        }
      }
      if (f > 0) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        var f = c.activeBomb ? 1 : 0;
        for (var g = 0; g < c.players.list.length; ++g) {
          if (c.players.list[g].diffuses) {
            return false;
          }
          if (c.players.list[g].lives > 0) {
            if (c.players.list[g].team == 1) {
              d++;
            } else {
              f++;
            }
          }
        }
        return d >= 1 && f >= 1;
      },
    ],
    onKill: function (c, d, f, g) {
      var h = f.loadout.indexOf(17);
      if (h > -1) {
        if (g && g != f) {
          f.weaponIndex = h;
          c.players.dropWeapon(f);
        } else {
          if (f.lastPicked[17] == null) {
            return;
          }
          var j = c.players.findEmptyPickup(f.lastPicked[17], true);
          if (j) {
            var k = [j.orgX, j.orgY, j.orgZ];
            c.updatePickup(j.uid, 17, null, true, k);
            d.broadcast(
              "game" + c.sid,
              "inat",
              -1,
              null,
              null,
              j.uid,
              17,
              true,
              k,
            );
          }
        }
      }
    },
    waitTimers: [
      {
        time: 10000,
        comp: true,
        noClear: true,
        msg: "match starting in ",
        trigger: function (c, d, f) {
          for (var g = 0; g < c.players.list.length; ++g) {
            if (c.players.list[g].spectating) {
              c.players.list[g].lives = 0;
            } else {
              f.send(
                c.players.list[g].id,
                "gmsg",
                c.players.list[g].team == 2
                  ? "DESTROY THE OBJECTIVE"
                  : "DEFEND THE OBJECTIVE",
              );
            }
          }
          c.unlockMove();
        },
      },
    ],
  },
  {
    id: "shrp",
    name: "Sharp Shooter",
    alias: "shrp",
    endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
    objWep: true,
    gameStart: function (c) {
      c.activeObjective = 0;
      c.nextWeapon(null, true);
    },
    forceClass: 9,
  },
  {
    id: "trai",
    name: "Traitor",
    alias: "trai",
    lives: 1,
    teams: true,
    noDeadChat: true,
    noKillFeed: true,
    teamOptions: ["Innocent", "Traitor"],
    teamColors: ["#37ad47", "#d13838"],
    showTeam: true,
    noRegen: true,
    fakeNames: true,
    noScoreK: true,
    dmgTeam: true,
    winCondition: function (c) {
      var d = 0;
      var f = 0;
      for (var g = 0; g < c.players.list.length; ++g) {
        if (c.players.list[g].lives > 0) {
          var h = c.players.list[g].lives;
          if (c.players.list[g].team == 1) {
            d += h;
          } else {
            f += h;
          }
        }
      }
      if (d > f) {
        return 1;
      } else {
        return 2;
      }
    },
    condition: [
      function (c) {
        var d = 0;
        var f = 0;
        for (var g = 0; g < c.players.list.length; ++g) {
          if (c.players.list[g].lives > 0 && c.players.list[g].active) {
            if (c.players.list[g].team == 1) {
              d++;
            } else {
              f++;
            }
          }
        }
        return d >= 1 && f >= 1;
      },
    ],
    waitTimers: [
      {
        time: 15000,
        msg: "picking traitors in ",
        trigger: function (c) {
          c.pickTraitors();
        },
      },
    ],
    onKill: function (c, d, f) {
      if (!c.waitTimers) {
        c.AI.spawn(null, 0, f.name + "'s Ghost", f.x, f.y, f.z);
      }
    },
    noReward: true,
    minPlayers: 3,
  },
  {
    id: "raid",
    name: "Raid",
    alias: "raid",
    sendR: 5,
    endStats: ["sid", "name", "score", "time", "dmg", "reward"],
    preventCustomGames: true,
    showMS: true,
    noRegen: true,
    lives: 1,
    gameTime: 360000,
    minPlayers: 1,
    waitTimers: [
      {
        time: 20000,
        msg: "starting in ",
      },
    ],
    condition: [
      function (c) {
        var d = 0;
        for (var f = 0; f < c.players.list.length; ++f) {
          if (c.players.list[f].lives > 0) {
            d++;
          }
        }
        if (d < 1) {
          return false;
        }
        for (f = 0; f < c.AI.ais.length; ++f) {
          if (
            !c.AI.ais[f].active &&
            c.AI.ais[f].behavType == 2 &&
            !c.waitTimers
          ) {
            for (var g = 0; g < c.players.list.length; ++g) {
              c.players.list[g].timer = c.lastTimer;
            }
            c.waitTimers = [
              {
                time: 10000,
                msg: "raid ends in ",
                trigger: function (h) {
                  h.gameTimer = "skip";
                },
              },
            ];
          }
        }
        return true;
      },
    ],
    noWeap: true,
    friendly: true,
    noClan: true,
    noFreeCam: true,
    specMaxD: 25,
  },
];
